import axios from "axios";

// Für Shared Hosting: relative URL nutzen (gleiche Domain)
// Für Entwicklung: REACT_APP_BACKEND_URL nutzen
const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || '';
const API = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API,
  headers: {
    "Content-Type": "application/json",
  },
});

// ============== CUSTOMERS ==============

export const getCustomers = async () => {
  const response = await api.get("/customers");
  return response.data;
};

export const getCustomer = async (id) => {
  const response = await api.get(`/customers/${id}`);
  return response.data;
};

export const createCustomer = async (data) => {
  const response = await api.post("/customers", data);
  return response.data;
};

export const updateCustomer = async (id, data) => {
  const response = await api.put(`/customers/${id}`, data);
  return response.data;
};

export const deleteCustomer = async (id) => {
  const response = await api.delete(`/customers/${id}`);
  return response.data;
};

// ============== TIME ENTRIES ==============

export const getTimeEntries = async (params = {}) => {
  const response = await api.get("/time-entries", { params });
  return response.data;
};

export const getTimeEntry = async (id) => {
  const response = await api.get(`/time-entries/${id}`);
  return response.data;
};

export const createTimeEntry = async (data) => {
  const response = await api.post("/time-entries", data);
  return response.data;
};

export const updateTimeEntry = async (id, data) => {
  const response = await api.put(`/time-entries/${id}`, data);
  return response.data;
};

export const deleteTimeEntry = async (id) => {
  const response = await api.delete(`/time-entries/${id}`);
  return response.data;
};

// ============== REPORTS ==============

export const getReportSummary = async (params = {}) => {
  const response = await api.get("/reports/summary", { params });
  return response.data;
};

export const getDailyReport = async (params = {}) => {
  const response = await api.get("/reports/daily", { params });
  return response.data;
};

export default api;
